import {
	AlertCenterData,
	IndividualReservation,
	OnboardSales
} from "@models/partnerInsights.model"
import { UtagData } from "@services/TealiumService"
import { GroupReservation as GroupReservationData } from "@models/partnerInsights.model"
import { FutureCompensation as FutureCompensationData } from "@models/partnerInsights.model"
import { CasinoReservation as CasinoReservationData } from "@models/partnerInsights.model"

export interface OnTrackingItem extends UtagData {
	event_name?: string
	row_position?: string[]
	booking_id?: string[]
	brand_code?: string[]
	ship_name?: string[]
	sail_date?: string[]
	depart_port?: string[]
	timeframe?: string
	alert_flag?: string[]
	group_id?: string[]
	alert_type?: string[]
	alert_due_date?: string[]
	dueDate?: string[]
	reservationType?: string
	box_filter?: string
}

interface EventTrackingItemsProps extends UtagData {
	event_name?: string
	page_url?: string
	alert_bar_content?: string
	interaction_type?: string
	category?: string
	event211?: number
	link_url?: string
	search_term?: string
	search_bar_name?: string
	nav_link_text?: string
	click_text?: string
	button_click?: string
	reward_balance?: string
	event222?: number
	chatbot_interaction_type?: string
	event214?: number
	frequency?: string
	training_type?: string
	box_filter?: string | object
	dining_unique_id?: string[]
	dining_title?: string[] | string
	dining_brand_code?: string[] | string
	row_position?: string[]
	deck_profile_id?: string
	deck_ship_code?: string
	deck_sail_date?: string
	deck?: string
	deck_room?: string
	brand_code?: string[] | string
	sail_date?: string[]
	ship_code?: string[]
	p_ship_code?: string[]
	p_brand?: string[]
	p_itinerary_code?: string[]
	p_package_id?: string[]
	p_depart_port?: string[]
	offer_unique_id?: string[]
	offer_title?: string[]
	offer_start_date?: string[]
	offer_end_date?: string[]
	ship?: string | string[]
	cuisine?: string
	price?: string
	ent_unique_id?: string[]
	ent_title?: string[]
	act_unique_id?: string[]
	act_title?: string[]
	bar_unique_id?: string[]
	bar_title?: string[]
	agency_id?: string
	email_optin?: string
	email_optin_brand?: string
	primary_mfa?: string
	secondary_mfa?: string
	prefer_language?: string
	pro_overview?: string
	agency_business_mod?: string
	agent_job_title?: string
	yrs_industry?: string
	your_country?: string
	zip_code?: string
	is_host_consortia?: string
	clia_id?: string
	sailing_region?: string | string[]
	agency_legal_name?: string
	company_type?: string
	business_type?: string
	agent_status_filter?: string
	alphabet_filter?: string
	results_per_page_filter?: string
	event_filter?: string
	date_filter?: string
	colonia_id?: string
	agent_tools?: string
	booking_id?: string[] | string
	certificate_type?: string
	certificate_option_code?: string
	status_filter?: string
	ship_name?: string[]
	modal_name?: string
	p_sail_date?: string[]
	p_destination_code?: string[]
	results_per_page?: string
	destination?: string[]
	depart_port?: string[]
	depart_date?: string[]
	cabin_prefer?: string
	table_size_seating_prefer?: string
	dining_time_prefer?: string
	bed_config_prefer?: string
	loyalty_id?: string
	brand?: string
	cruise_type?: string
	duration?: string
	port_of_call?: string
	currency_filter?: string
	p_cabin_class?: string[]
	currencyCode?: string[]
	product_price?: string[]
}

export interface EventTrackingProps {
	event_name: string
	action?: string
	interactionType?: string
	category?: string
	event211?: number
	link_url?: string
	search_term?: string
	searchbarName?: string
	navLinkText?: string
	clickText?: string
	buttonClick?: string
	rewardBalance?: string
	event222?: number
	chatbot_interaction_type?: string
	event214?: number
	frequency?: string
	training_type?: string
	box_filter?: string | string[] | object
	dining_unique_id?: string[]
	dining_title?: string[] | string
	dining_brand_code?: string[] | string
	row_position?: string[]
	deck_profile_id?: string
	deck_ship_code?: string
	deck_sail_date?: string
	deck?: string
	deck_room?: string
	brand_code?: string[] | string
	sail_date?: string[]
	ship_code?: string[]
	p_ship_code?: string[]
	p_brand?: string[]
	p_itinerary_code?: string[]
	p_package_id?: string[]
	p_depart_port?: string[]
	offer_unique_id?: string[]
	offer_title?: string[]
	offer_start_date?: string[]
	offer_end_date?: string[]
	ship?: string | string[]
	cuisine?: string
	price?: string
	ent_unique_id?: string[]
	ent_title?: string[]
	act_unique_id?: string[]
	act_title?: string[]
	bar_title?: string[]
	bar_unique_id?: string[]
	agency_id?: string
	email_optin?: string
	email_optin_brand?: string
	primary_mfa?: string
	secondary_mfa?: string
	prefer_language?: string
	pro_overview?: string
	agency_business_mod?: string
	agent_job_title?: string
	yrs_industry?: string
	your_country?: string
	is_host_consortia?: string
	sailing_region?: string | string[]
	agency_legal_name?: string
	company_type?: string
	business_type?: string
	clia_id?: string
	zip_code?: string
	agent_status_filter?: string
	alphabet_filter?: string
	results_per_page_filter?: string
	event_filter?: string
	date_filter?: string
	colonia_id?: string
	agent_tools?: string
	booking_id?: string[] | string
	certificate_type?: string
	certificate_option_code?: string
	status_filter?: string
	ship_name?: string[]
	modal_name?: string
	p_sail_date?: string[]
	p_destination_code?: string[]
	destination?: string[]
	depart_port?: string[]
	depart_date?: string[]
	results_per_page?: string
	cabin_prefer?: string
	table_size_seating_prefer?: string
	dining_time_prefer?: string
	bed_config_prefer?: string
	loyalty_id?: string
	cruise_type?: string
	brand?: string
	duration?: string
	port_of_call?: string
	currency_filter?: string
	p_cabin_class?: string[]
	currencyCode?: string[]
	product_price?: string[]
}

interface EventFeaturedTrackingProps {
	event_name: string
	row_position?: string[]
	offer_unique_id?: string[]
	offer_title?: string[]
	offer_start_date?: string[]
	offer_end_date?: string[]
	brand_code?: string[]
	expired_offer?: string[]
	offers_for?: string | undefined
	destination?: string | undefined
	box_filter?: string | undefined
	navLinkText?: string
	category?: string
	interaction_type?: string
	link_url?: string
	ship?: string | string[] | undefined
	offer_expired_within?: string
	page_url?: string
	nav_link_text?: string
}
interface EventFeaturedTrackingItemProps
	extends EventFeaturedTrackingProps,
		UtagData {
	page_url?: string
}

interface EventPromotionTrackingItemProps
	extends EventPromtionItemsProps,
		UtagData {
	page_url?: string
	p_ship_code?: string | string[]
	p_brand?: string | string[]
	p_sail_date?: string | string[]
	p_itinerary_code?: string | string[]
	p_package_id?: string | string[]
	p_cabin_class?: string[]
	p_depart_port?: string | string[]
	promo_name?: string[]
}

export interface EventPromtionItemsProps {
	event_name: string
	row_position?: string[]
	promo_id?: (string | number)[]
	p_ship_code?: string | string[]
	p_brand?: string | string[]
	p_sail_date?: string | string[]
	p_itinerary_code?: string | string[]
	p_package_id?: string | string[]
	product_quantity?: string[]
	p_cabin_class?: string[]
	currencyCode?: string[]
	product_price?: string[] | number[]
	p_depart_port?: string | string[]
	promo_name?: string[]
}

type EventRow =
	| OnboardSales
	| GroupReservationData
	| FutureCompensationData
	| CasinoReservationData
	| IndividualReservation
	| AlertCenterData

export function isOnboardSales(row: EventRow): row is OnboardSales {
	return (
		(row as OnboardSales).depositExpiring !== undefined ||
		(row as OnboardSales).shipGuestCruisedOn !== undefined
	)
}

export function isGroupReservationData(
	row: EventRow
): row is GroupReservationData {
	return (row as GroupReservationData).totalRooms !== undefined
}

export function isFutureCompensationData(
	row: EventRow
): row is FutureCompensationData {
	return (row as FutureCompensationData).compensationType !== undefined
}

export function isCasinoReservation(
	row: EventRow
): row is CasinoReservationData {
	return (row as CasinoReservationData).notes !== undefined
}

export function isIndividualReservation(
	row: EventRow
): row is IndividualReservation {
	const bookingId = (row as IndividualReservation).flexPay
	return typeof bookingId === "string" && bookingId.length > 0
}

export function isAlertCenter(row: EventRow): row is AlertCenterData {
	const alerts = (row as AlertCenterData).alerts
	return typeof alerts === "object"
}

const extractTrackingValues = (
	row: EventRow,
	index?: number,
	timeframe?: string,
	box_filter?: string,
	departPort?: string[],
	reservationType?: string
) => {
	let shipNames: string[] = []
	let bookingIds: string[] = []
	let alertFlags: string[] = []
	let groupIds: string[] = [""]
	let dueDate: string[] = []
	let alertTypes: string[] = [""]
	let brandCodes: string[] = []
	let sailDates: string[] = []
	let alertDueDates: string[] = [""]

	const rowPosition: string[] = [
		(index !== undefined ? index + 1 : 1).toString()
	]
	let departPorts: string[] = [""]

	switch (true) {
		case isOnboardSales(row):
			shipNames = [row.ship || ""]
			bookingIds = [row.bookingId?.toString() || ""]
			alertFlags = [row?.alerts ? "1" : "0"]
			groupIds = [row?.groupId?.toString() || ""]
			brandCodes = [row?.brand || ""]
			sailDates = [
				row?.sailingDate
					? new Date(row.sailingDate).toLocaleDateString("en-US")
					: ""
			]
			timeframe
			box_filter
			break

		case isGroupReservationData(row):
			shipNames = [row?.shipName ?? row?.ship ?? ""]
			alertFlags = [row?.alerts ? "1" : "0"]
			groupIds = [row?.groupId?.toString() || ""]
			timeframe
			box_filter
			sailDates = [
				row?.sailDate ? new Date(row.sailDate).toLocaleDateString("en-US") : ""
			]
			brandCodes = [row?.brand || ""]
			break

		case isFutureCompensationData(row):
			shipNames = [row.shipName || ""]
			bookingIds = [row.bookingId?.toString() || ""]
			alertFlags = [row?.alerts ? "1" : "0"]
			groupIds = [row?.groupId?.toString() || ""]
			brandCodes = [row?.brand || ""]
			sailDates = [
				row?.sailingDate
					? new Date(row.sailingDate).toLocaleDateString("en-US")
					: ""
			]
			timeframe
			box_filter
			break

		case isCasinoReservation(row):
			shipNames = [row.ship || ""]
			bookingIds = [row.bookingId?.toString() || ""]
			brandCodes = [row?.brand || ""]
			sailDates = [
				row?.sailingDate
					? new Date(row.sailingDate).toLocaleDateString("en-US")
					: ""
			]
			timeframe
			box_filter
			break

		case isIndividualReservation(row):
			shipNames = [row.shipName || ""]
			bookingIds = [row.bookingId ? row.bookingId?.toString() : ""]
			alertFlags = [row?.alerts ? "1" : "0"]
			groupIds = [row?.groupId?.toString() || ""]
			dueDate = [
				row?.balanceDue
					? new Date(row?.balanceDue?.date).toLocaleDateString("en-US")
					: ""
			]
			alertTypes = ["dinningConflict"]
			brandCodes = [row?.brand || ""]
			sailDates = [
				row?.sailingDate
					? new Date(row.sailingDate).toLocaleDateString("en-US")
					: ""
			]
			timeframe
			box_filter
			break

		case isAlertCenter(row):
			shipNames = [row.shipName || ""]
			bookingIds = [row.bookingId?.toString() || ""]
			alertFlags = [row?.alerts ? "1" : "0"]
			alertTypes = [row?.alerts[0]?.type || ""]
			alertDueDates = [row?.alerts[0]?.dueDate || ""]
			brandCodes = [row?.brandCode || ""]
			groupIds = [row?.groupId?.toString() || ""]
			sailDates = [row?.alerts[0]?.dueDate || ""]
			timeframe
			box_filter
			departPorts = departPort ?? [""]
			reservationType

			break

		default:
			shipNames = [""]
			break
	}
	return {
		ship_name: shipNames,
		row_position: rowPosition,
		booking_id: bookingIds,
		brand_code: brandCodes,
		sail_date: sailDates,
		depart_port: departPorts,
		alert_flag: alertFlags,
		group_id: groupIds,
		timeframe: timeframe,
		alert_type: alertTypes,
		alert_due_date: alertDueDates,
		dueDate: dueDate,
		box_filter: box_filter,
		reservationType: reservationType
	}
}

export const eventTracking = (
	row?: EventRow,
	index?: number,
	eventName?: string,
	timeframe?: string,
	box_filter?: string,
	departPort?: string[],
	reservationType?: string
): OnTrackingItem | null => {
	if (!row) return null

	const extractedValues = extractTrackingValues(
		row,
		index,
		timeframe,
		box_filter,
		departPort,
		reservationType
	)
	return {
		event_name: eventName || "",
		...extractedValues
	}
}

export const sendEventTracking = (payloads: OnTrackingItem[]): void => {
	if (payloads.length > 0) {
		const shipNames: string[] = []
		const rowPositions: string[] = []
		const bookingIds: string[] = []
		const brandCodes: string[] = []
		const sailDates: string[] = []
		const alertFlags: string[] = []
		const groupIds: string[] = []
		const alertType: string[] = []
		const alertDueDate: string[] = []
		const dueDate: string[] = []
		let departPorts: string[] = []
		let timeframe = ""
		let eventName = ""
		let reservationType = ""
		let box_filter = ""

		for (const payload of payloads) {
			shipNames.push(...(payload.ship_name || []))
			rowPositions.push(...(payload.row_position || []))
			bookingIds.push(...(payload.booking_id || []))
			brandCodes.push(...(payload.brand_code || []))
			sailDates.push(...(payload.sail_date || []))
			alertFlags.push(...(payload.alert_flag || []))
			groupIds.push(...(payload.group_id || []))
			alertType.push(...(payload.alert_type || []))
			alertDueDate.push(...(payload.alert_due_date || []))
			dueDate.push(...(payload.dueDate || []))
			timeframe = payload?.timeframe || ""
			eventName = payload.event_name || ""
			departPorts = payload?.depart_port || []
			reservationType = payload?.reservationType || ""
			box_filter = payload?.box_filter || ""
		}

		const finalPayload: OnTrackingItem = {
			event_name: eventName,
			ship_name: shipNames,
			row_position: rowPositions,
			booking_id: bookingIds,
			brand_code: brandCodes,
			sail_date: sailDates,
			depart_port: departPorts,
			alert_flag: alertFlags,
			alert_type: alertType,
			alert_due_date: alertDueDate,
			dueDate: dueDate,
			group_id: groupIds,
			timeframe: timeframe,
			reservationType: reservationType,
			box_filter: box_filter
		}
		window.utag?.link(finalPayload)
	}
}

export const eventTrackingItems = ({
	event_name,
	action,
	interactionType,
	category,
	event211,
	link_url,
	search_term,
	searchbarName,
	navLinkText,
	clickText,
	buttonClick,
	rewardBalance,
	event222,
	chatbot_interaction_type,
	event214,
	frequency,
	training_type,
	box_filter,
	dining_unique_id,
	dining_title,
	dining_brand_code,
	row_position,
	deck_profile_id,
	deck_ship_code,
	deck_sail_date,
	deck,
	deck_room,
	brand_code,
	sail_date,
	ship_code,
	p_ship_code,
	p_brand,
	p_itinerary_code,
	p_package_id,
	p_depart_port,
	offer_unique_id,
	offer_title,
	offer_start_date,
	offer_end_date,
	ship,
	cuisine,
	price,
	ent_unique_id,
	ent_title,
	act_unique_id,
	act_title,
	bar_unique_id,
	bar_title,
	agency_id,
	email_optin,
	email_optin_brand,
	primary_mfa,
	secondary_mfa,
	prefer_language,
	pro_overview,
	agency_business_mod,
	agent_job_title,
	yrs_industry,
	your_country,
	zip_code,
	is_host_consortia,
	clia_id,
	sailing_region,
	agency_legal_name,
	company_type,
	business_type,
	agent_status_filter,
	alphabet_filter,
	results_per_page_filter,
	event_filter,
	date_filter,
	colonia_id,
	agent_tools,
	booking_id,
	certificate_type,
	certificate_option_code,
	status_filter,
	ship_name,
	modal_name,
	p_sail_date,
	p_destination_code,
	destination,
	depart_port,
	depart_date,
	results_per_page,
	cabin_prefer,
	table_size_seating_prefer,
	dining_time_prefer,
	bed_config_prefer,
	loyalty_id,
	cruise_type,
	brand,
	duration,
	port_of_call,
	currency_filter,
	p_cabin_class,
	currencyCode,
	product_price
}: EventTrackingProps): void => {
	const payload: EventTrackingItemsProps = {
		event_name: event_name,
		page_url: window.location.href,
		alert_bar_content: action,
		interaction_type: interactionType,
		category: category,
		event211: event211 || 0,
		link_url: link_url,
		search_term: search_term,
		search_bar_name: searchbarName,
		nav_link_text: navLinkText,
		click_text: clickText,
		button_click: buttonClick,
		reward_balance: rewardBalance,
		event222: event222 || 0,
		chatbot_interaction_type: chatbot_interaction_type,
		event214: event214 || 0,
		frequency: frequency,
		training_type: training_type,
		box_filter: box_filter || "",
		dining_unique_id: dining_unique_id,
		dining_title: dining_title,
		dining_brand_code: dining_brand_code,
		row_position: row_position,
		deck_profile_id: deck_profile_id,
		deck_ship_code: deck_ship_code,
		deck_sail_date: deck_sail_date,
		deck: deck,
		deck_room: deck_room,
		brand_code: brand_code,
		sail_date: sail_date,
		ship_code: ship_code,
		p_ship_code: p_ship_code,
		p_brand: p_brand,
		p_itinerary_code: p_itinerary_code,
		p_package_id: p_package_id,
		p_depart_port: p_depart_port,
		offer_unique_id: offer_unique_id,
		offer_title: offer_title,
		offer_start_date: offer_start_date,
		offer_end_date: offer_end_date,
		ship: ship,
		cuisine: cuisine,
		price: price,
		ent_unique_id: ent_unique_id,
		ent_title: ent_title,
		act_unique_id: act_unique_id,
		act_title: act_title,
		bar_unique_id: bar_unique_id,
		bar_title: bar_title,
		agency_id: agency_id,
		email_optin: email_optin,
		email_optin_brand: email_optin_brand,
		primary_mfa: primary_mfa,
		secondary_mfa: secondary_mfa,
		prefer_language: prefer_language,
		pro_overview: pro_overview,
		agency_business_mod: agency_business_mod,
		agent_job_title: agent_job_title,
		yrs_industry: yrs_industry,
		your_country: your_country,
		zip_code: zip_code,
		is_host_consortia: is_host_consortia,
		clia_id: clia_id,
		sailing_region: sailing_region,
		agency_legal_name: agency_legal_name,
		company_type: company_type,
		business_type: business_type,
		agent_status_filter: agent_status_filter,
		alphabet_filter: alphabet_filter,
		results_per_page_filter: results_per_page_filter,
		event_filter: event_filter,
		date_filter: date_filter,
		colonia_id: colonia_id,
		agent_tools: agent_tools,
		booking_id: booking_id,
		certificate_type: certificate_type,
		certificate_option_code: certificate_option_code,
		status_filter: status_filter,
		ship_name: ship_name,
		modal_name: modal_name,
		p_sail_date: p_sail_date,
		p_destination_code: p_destination_code,
		destination: destination,
		depart_port: depart_port,
		depart_date: depart_date,
		results_per_page: results_per_page,
		cabin_prefer: cabin_prefer,
		table_size_seating_prefer: table_size_seating_prefer,
		dining_time_prefer: dining_time_prefer,
		bed_config_prefer: bed_config_prefer,
		loyalty_id: loyalty_id,
		cruise_type: cruise_type,
		brand: brand,
		duration: duration,
		port_of_call: port_of_call,
		currency_filter: currency_filter,
		p_cabin_class: p_cabin_class,
		currencyCode: currencyCode,
		product_price: product_price
	}
	window?.utag?.link?.(payload)
}

export const eventFeaturedTrackingItems = ({
	event_name,
	row_position,
	offer_unique_id,
	offer_title,
	offer_start_date,
	offer_end_date,
	brand_code,
	expired_offer,
	offers_for,
	destination,
	box_filter,
	navLinkText,
	category,
	interaction_type,
	link_url,
	ship,
	offer_expired_within,
	nav_link_text,
	page_url
}: EventFeaturedTrackingProps): void => {
	const payload: EventFeaturedTrackingItemProps = {
		event_name: event_name,
		page_url: page_url ?? window.location.href,
		row_position: row_position,
		offer_unique_id: offer_unique_id,
		offer_title: offer_title,
		offer_start_date: offer_start_date,
		offer_end_date: offer_end_date,
		brand_code: brand_code,
		expired_offer: expired_offer,
		offers_for: offers_for,
		destination: destination,
		box_filter: box_filter,
		navLinkText: navLinkText,
		category: category,
		interaction_type: interaction_type,
		link_url: link_url,
		ship: ship,
		offer_expired_within: offer_expired_within,
		nav_link_text: nav_link_text
	}
	window?.utag?.link?.(payload)
}

export const eventPromotionItems = ({
	event_name,
	row_position,
	promo_id,
	p_ship_code,
	p_brand,
	p_sail_date,
	p_itinerary_code,
	p_package_id,
	product_quantity,
	p_cabin_class,
	currencyCode,
	product_price,
	p_depart_port,
	promo_name
}: EventPromtionItemsProps): void => {
	const payload: EventPromotionTrackingItemProps = {
		event_name: event_name,
		page_url: window.location.href,
		row_position: row_position,
		promo_id: promo_id,
		p_ship_code: p_ship_code,
		p_brand: p_brand,
		p_sail_date: p_sail_date,
		p_itinerary_code: p_itinerary_code,
		p_package_id: p_package_id,
		product_quantity: product_quantity,
		p_cabin_class: p_cabin_class,
		currencyCode: currencyCode,
		product_price: product_price,
		p_depart_port: p_depart_port,
		promo_name: promo_name
	}
	window.utag.link(payload)
}
